import React, { Component } from 'react';
import ShopQueueDMK from './queue_dmk';
import ShopListItemDMK from './shop_list_item_dmk';
import {observer, inject} from 'mobx-react';
import styled from 'styled-components';
import EtaContainerDmk from '../../assets/dmk-eta-container.png';


const ShopsContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    background-color: #E9E8E8;
    padding: 40px 40px 40px 50px;
`

@inject('RootStore')
@observer
export default class ShopListWidgetWideDMK extends Component {
    render() {
        const shopList = this.props.RootStore.hallStore.shopsList;
        return (
            <ShopsContainer>
                {shopList.map((shop, idx) => {
                const {name, id, queue_length, title, eta, description_line_1} = shop;
                return (
                    <ShopListItemDMK name={description_line_1 || name} id={id} queueLength={queue_length} title={title} eta={eta}/>
                )})}
                {(shopList.length % 2) && <ShopListItemDMK/>}
            </ShopsContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/food_court_shop_list_panel/shop_list_widget_wide_dmk.jsx